// App utils
import { datajsArray } from '../shared/utils';

(function() {
	const toggleQuicklinks = e => {
		e.preventDefault();
		const icon = e.target;
		icon.closest('.c-quickLinks').classList.toggle('active');
	};

	const preventFocus = e => {
		e.preventDefault();
	};

	const quicklinksToggle = () => {
		datajsArray('quicklinks-toggle').forEach(item => item.addEventListener('click', toggleQuicklinks));
		datajsArray('quicklinks-toggle').forEach(item => item.addEventListener('mousedown', preventFocus));
	};

	document.addEventListener('DOMContentLoaded', quicklinksToggle);
})();
